module.exports = __webpack_public_path__ + "media/start_bet.15810015.mp3";